"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorSlice = errorSlice;
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const strings_1 = require("../../constants/strings");
const lexico = new lexico_1.default();
const errorInitialState = {
    error: {
        heading: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
            ? strings_1.errorStrings.DEFAULT
            : lexico.trc('Error message', 'Something is not right'),
        message: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
            ? strings_1.errorStrings.DEFAULT
            : lexico.trc('Try again error message', 'The action you’re trying to perform cannot be completed. In some cases simply trying again helps.'),
        preventShowErrorPage: false,
    },
};
function errorSlice(set) {
    return {
        ...errorInitialState,
        setErrorMessage({ heading = '', message = '' }) {
            set((state) => {
                state.error.heading = heading;
                state.error.message = message;
                return state;
            }, false, '[SetErrorMessage]');
        },
        setPreventShowErrorPage(preventShowErrorPage) {
            set((state) => {
                state.error.preventShowErrorPage = preventShowErrorPage;
                return state;
            }, false, '[SetPreventShowErrorPage]');
        },
    };
}
